import { render, staticRenderFns } from "./CrewLaborDashboard.vue?vue&type=template&id=15fa822e"
import script from "./CrewLaborDashboard.vue?vue&type=script&lang=js"
export * from "./CrewLaborDashboard.vue?vue&type=script&lang=js"
import style0 from "./CrewLaborDashboard.vue?vue&type=style&index=0&id=15fa822e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports